import { render } from "./PointChart.vue?vue&type=template&id=27a9b10e"
import script from "./PointChart.vue?vue&type=script&lang=js"
export * from "./PointChart.vue?vue&type=script&lang=js"

import "./PointChart.vue?vue&type=style&index=0&id=27a9b10e&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__